import React from 'react'
import 'react-calendar/dist/Calendar.css'
import { useTranslation } from 'react-i18next'
import CardsModal from '../../components/calendar/CardsModal'
import { MainLayout } from '../../components/layout'
import { useCalendar } from '../../hooks/useCalendar'
import './Calendar.css'

import { Calendar } from 'antd'
import uzUZ from 'antd/es/calendar/locale/uz_UZ'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import 'dayjs/locale/uz'

export const CalendarPage: React.FC = () => {
  const { t } = useTranslation()

  const {
    cards,
    selectedDate,
    currentMonth,
    isModalOpen,
    cardsForSelectedDate,
    isLoading,
    error,
    getCardsForDate,
    getCardColor,
    handleDateClick,
    handleActiveStartDateChange,
    setIsModalOpen,
  } = useCalendar()

  if (isLoading) {
    return (
      <MainLayout title={t('calendar.title')}>
        <div className="loading-container">
          <div className="spinner" />
        </div>
      </MainLayout>
    )
  }

  if (error) {
    return (
      <MainLayout title={t('calendar.title')}>
        <div className="error-container">
          {t('calendar.error')}: {error.message}
        </div>
      </MainLayout>
    )
  }

  /**  Kun ichidagi cardlarni chizish */
  const dateCellRender = (value: Dayjs) => {
    const dayCards = getCardsForDate(value.toDate())
    if (!dayCards.length) return null

    return (
      <div className="events-container">
        {dayCards.slice(0, 3).map((card) => (
          <span
            key={card.id}
            className="event-dot"
            style={{ backgroundColor: getCardColor(card) }}
            title={card.title}
          />
        ))}
        {dayCards.length > 3 && (
          <span className="more-events">+{dayCards.length - 3}</span>
        )}
      </div>
    )
  }

  return (
    <MainLayout title={t('calendar.title')}>
      <div className="calendar-page">
        <div className="calendar-wrapper">
          <Calendar
            locale={uzUZ}
            value={dayjs(currentMonth)}
            dateCellRender={dateCellRender}
            onSelect={(date: Dayjs) => handleDateClick(date.toDate())}
            onPanelChange={(date) => {
              handleActiveStartDateChange(date.toDate())
            }}
          />
        </div>

        {/* Modal */}
        <CardsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          date={selectedDate}
          cards={cardsForSelectedDate}
        />
      </div>
    </MainLayout>
  )
}

export default CalendarPage
